import { FC, PropsWithChildren } from 'react';
import { StyledFullWidthLayoutWrapper } from './FullWidthLayout.styles';
import { PageHeader, UserWidgetProps } from '../../organisms/PageHeader';
import { PageHeading } from '../../atoms/PageHeading';

export interface FullWidthLayoutProps extends PropsWithChildren {
  userWidget: UserWidgetProps;
  heading: {
    title: string | JSX.Element;
    subtitle?: string | JSX.Element;
    loading?: boolean;
  };
}

/**
 * A simple full-width layout. Good for conent with a sidebar such as admin pages.
 */
export const FullWidthLayout: FC<FullWidthLayoutProps> = ({
  children,
  userWidget: { login, logout, userPhoto, userName },
  heading: { title, subtitle, loading },
}) => {
  return (
    <StyledFullWidthLayoutWrapper>
      <PageHeader
        login={login}
        logout={logout}
        userPhoto={userPhoto}
        userName={userName}
        $fullWidth={true}
      />
      <PageHeading
        data-testid="heading"
        title={title}
        subtitle={subtitle}
        loading={loading}
      />
      {children}
    </StyledFullWidthLayoutWrapper>
  );
};

export default FullWidthLayout;
